import { makeAutoObservable } from "mobx";

/**
 * UI-only state for the desktop "Trade History" modal. The Sidebar's History
 * nav item lives outside the Trading screen's component tree, so opening the
 * modal from there (instead of navigating to the standalone /history page)
 * needs state shared between the two — this store is that link.
 */
class HistoryModalStore {
  isOpen = false;

  constructor() {
    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
}

export const historyModalStore = new HistoryModalStore();
